import React from 'react'

const TimeTableHeaderItem = ({ model }) => {
    return (
        <div className="" style={{ width: "100%", height: "3rem", display: "flex", justifyContent: "center", textAlign: "center", backgroundColor: "#c6e9ff " }}>
            {model?.name ?? "پیشفرض"}
        </div>
    );
};

export default TimeTableHeaderItem;